import { fetch_request } from './request';
import { getListOfCountries, setRelationDirections, setRelations } from '../redux/actions';
import store from '../redux/store';
import { primeRelationsCache } from '../hooks/useRelations';
import { enrichDirections } from './relationsLoader';

const CACHE_KEY = 'staticData:v1';
const readCache = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed.payload || null;
  } catch {
    return null;
  }
};

const writeCache = (payload) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ payload }));
  } catch {
    // ignore
  }
};

let inflight = null;
export const loadStaticData = async (forceRefresh = false) => {
  const cached = !forceRefresh && readCache();
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = fetch_request('/api/static_data')
    .then((res) => res.json())
    .then((data) => {
      const relations = Array.isArray(data?.relations) ? data.relations : null;
      const enriched =
        relations && Array.isArray(data?.relation_directions)
          ? { ...data, relation_directions: enrichDirections(data.relation_directions, relations) }
          : data;
      writeCache(enriched);
      inflight = null;
      return enriched;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });
  return inflight;
};

export const primeStaticData = async (forceRefresh = false) => {
  const data = await loadStaticData(forceRefresh);
  const relations = Array.isArray(data?.relations) ? data.relations : null;
  if (relations) {
    store.dispatch(setRelations(relations));
    primeRelationsCache(relations);
  }
  if (Array.isArray(data?.relation_directions) && relations) {
    const directions = enrichDirections(data.relation_directions, relations);
    store.dispatch(setRelationDirections(directions));
  }
  if (data?.countries) {
    store.dispatch(getListOfCountries({ countries: data.countries }));
  }
  return data;
};

export const getCachedStaticData = () => readCache();
